"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sidebar_service_1 = require("./sidebar.service");
var CloseSidebar = (function () {
    function CloseSidebar(_sidebarService) {
        this._sidebarService = _sidebarService;
    }
    /** @internal */
    CloseSidebar.prototype._onClick = function () {
        this._sidebarService.close();
    };
    return CloseSidebar;
}());
CloseSidebar.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[closeSidebar]',
                host: {
                    '(click)': '_onClick()'
                }
            },] },
];
/** @nocollapse */
CloseSidebar.ctorParameters = function () { return [
    { type: sidebar_service_1.SidebarService, },
]; };
exports.CloseSidebar = CloseSidebar;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-sidebar/lib/close.directive.js
// module id = 275
// module chunks = 1